<template>
  <div class="over-money" @keyup.enter="enterSearch">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="100px">
      <el-form-item label="主子客户ID" prop="relatedCode">
        <el-input v-model="form.relatedCode" placeholder="请输入主子客户ID"></el-input>
      </el-form-item>
      <el-form-item label="客户名称" prop="customerName">
        <el-input v-model="form.customerName" placeholder="请输入客户名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch('search')">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="relatedCode"
        label="主子客户ID"
        width="160"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="customerName"
        label="主客户名称"
        width="160"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="subAccounts"
        label="子客户名称"
        show-overflow-tooltip>
        <template slot-scope="scope">
          {{scope.row.subAccounts && scope.row.subAccounts.length ? (scope.row.subAccounts.map(item => item.customerName).filter(name => name !== undefined && name !== null).join('、')) : ''}}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :current-page="listState.pageNo"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange">
    </el-pagination>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'parentAndChildCustomer',
  data () {
    return {
      form: {
        relatedCode: '',
        customerName: ''
      },
      tableData: [],
      total: 0,
      listState: {
        pageNo: 1,
        pageSize: 10
      }
    }
  },
  methods: {
    ...mapActions(['getParentAndChildCustomer']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch('search')
      }
    },
    // 搜索
    handleSearch (val) {
      if (val && val === 'search') {
        this.listState.pageNo = 1
      }
      const params = {
        ...this.form,
        ...this.listState
      }
      this.getParentAndChildCustomer(params).then(res => {
        if (res.success) {
          const { list = [], total, pageNum, pageSize } = res.data
          this.tableData = list
          this.total = total
          this.listState.pageNo = pageNum
          this.listState.pageSize = pageSize
        }
      })
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.listState.pageNo = 1
      this.listState.pageSize = val
      this.handleSearch()
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.listState.pageNo = val
      this.handleSearch()
    },
    // 查询表单，表格重置
    handleReset () {
      this.listState.pageNo = 1
      this.$refs.form.resetFields()
      this.handleSearch()
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

<style scoped>
  .output-box{
    margin-top: 20px;
    text-align: right;
  }
  .input-page, .select-page{
    width: 98px;
    margin: 0 15px;
  }
  .input-page, .select-page-btn{
    width: 120px;
    margin: 0 15px;
  }
</style>
